<template>
	<div id="spring-sale-promotion">
		<hr class="my-16" />
		<h4 class="font-body text-xl font-medium">
			Spring Sale 2025 Promotion
		</h4>

		<div class="mt-8 space-y-5 font-body text-lg">
			<ul class="li-padding-left space-y-5 pl-5">
				<li>
					This offer is valid to new sign ups in NSW, QLD, and VIC
					aged 21 and over.
				</li>
				<li>
					The promotion runs from 12:01 AM AEST on 18 August 2025 to
					11:59 PM AEST on 30 September 2025.
				</li>
				<li>
					Eligible participants must create a new carbar account
					during the Promotional Period.
				</li>
				<li>Model availability is limited and exclusions apply.</li>
				<li>Swaps are not included.</li>
				<li>
					This offer does not apply to fleet vehicles or
					tools-of-trade subscriptions and cannot be combined with
					other discounts, except for the refer-a-friend program.
				</li>
				<li>Standard subscription fees and terms apply.</li>
				<li>
					Carbar reserves the right to verify eligibility and
					disqualify fraudulent or duplicate accounts
				</li>
			</ul>
		</div>
	</div>
</template>
